import { fromWei } from "@/lib/web3x-es/utils/units";
import { Contract } from "./Contract";

export class StakingManager extends Contract {
  public constructor() {
    // eslint-disable-next-line
    super(require("./artifacts/StakingManager.json"));
  }

  // Read Methods

  /**
   * Get staked amount for the provided address.
   * NOTE: we ask for pool 0
   * @param address to query
   */
  public async totalStaked(address: string) {
    const userInfo = await this.instance.methods.userInfo(0, address).call();
    return fromWei(userInfo.amount, "ether");
  }

  /**
   * Get claimable rewards for the provided address.
   * NOTE: we ask for pool 0
   * @param address to query
   */
  public async claimableRewards(address: string) {
    const value = await this.instance.methods.pendingRewards(0, address).call();
    return fromWei(value, "ether");
  }

  /**
   * Get total rewards per second of the contract
   */
  public async claimablePerSecond() {
    const value = await this.instance.methods.claimablePerSecond().call();
    return fromWei(value, "ether");
  }

  // Write Methods

  /**
   * Stake the designated amount
   * @param amount to stake
   */
  public stake(amount: string) {
    return this.encodeABI("stake", 0, amount);
  }

  /**
   * Unstake the designated amount
   * @param amount to stake
   */
  public unstake(amount: string) {
    return this.encodeABI("unstake", 0, amount);
  }

  /**
   * Claim the staking rewards
   */
  public claim() {
    return this.encodeABI("claim", 0);
  }
}
